<template>
  <div class="main">
    <heads></heads>
    <navs></navs>
    <banners></banners>
    <div class="content">
      <gerenzhongxinnav />
      <div class="gezx-nr">
        <div class="gezx-nr-title"><span>活动成果</span></div>
        <div class="gezx-nr-con">
          <div class="gezx-nr-cons">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="hdname" label="活动名称" width="480" />
              <el-table-column label="投稿状态">
                <template #default="scope">
                  <el-text class="mx-1" :type="scope.row.st==1?'info':scope.row.st==2?'primary':'danger'">{{scope.row.st==1?'待审核':scope.row.st==2?'审核通过':'审核未通过'}}</el-text>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <footers></footers>
  </div>
</template>

<script setup>
import { post, get } from "@/utils/index";
import { ElMessage } from "element-plus";
import { User, Medal } from "@element-plus/icons-vue";
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
// 表格数据
let tableData = reactive([]);

// 获取活动
const gethuodong1 = () => {
  get("/api/User/GetUserHdjkkpcg").then((res) => {
    res.data.forEach((e) => {
      let opt = {};
      opt.hdname = e.hdname;
      opt.title = e.title;
      opt.st = e.st;
      tableData.push(opt);
    });
    
  });
};
const gethuodong2 = () => {
 get("/api/User/GetUserHdKpjxy").then((res) => {
    res.data.forEach((e) => {
      let opt = {};
      opt.hdname = e.hdname;
      opt.title = e.title;
      opt.st = e.st;
      tableData.push(opt);
    });
    
  });
};
 gethuodong1();
 gethuodong2();
</script>

<style scoped>
.main {
  background: #f5fcff;
}
.content {
  width: 1200px;
  height: auto;
  margin: auto;
  padding: 30px 0;
}
.content::after {
  content: "";
  display: table;
  clear: both;
}

.gezx-nr {
  float: right;
  width: 900px;
  height: auto;
  min-height: 490px;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.gezx-nr-title {
  position: relative;
  padding: 20px 0 0 0;
  border-bottom: 1px solid #ccc;
  font-weight: bold;
}
.gezx-nr-title > span {
  position: absolute;
  left: 10px;
  top: 8px;
  display: block;
  width: 80px;
  height: 30px;
  text-align: center;
  background: #fff;
}
.gezx-nr-con {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
